module.exports = function(obj) {
obj || (obj = {});
var __t, __p = '';
with (obj) {
__p += '<footer class="container">\r\n  <div class="cont-c">\r\n    <div class="logo"><img src="' +
((__t = (require('../../assets/images/footer_logo.png'))) == null ? '' : __t) +
'" alt=""></div>\r\n    <div class="nav">\r\n      <a href="index.html"><span>Home</span></a>\r\n      <a href="i#"><span>FEATURES</span></a>\r\n      <a href="https://www.predatortires.com" target="_blank"><span>PREDATOR TIRES</span></a>\r\n      <a href="media.html"><span>media center</span></a>\r\n      <a href="subscribe.html"><span>subscribe</span></a>\r\n      <a href="about.html"><span>About</span></a>\r\n    </div>\r\n  </div>\r\n</footer>';

}
return __p
}